import React, { useState } from 'react'
import CustomModal from 'cms/components/shared/CustomModal';
import { deleteItem } from 'cms/utils/Network';
import { getYoutubeId, isYoutube } from 'cms/utils';
import UrlEmbed from 'cms/components/UrlEmbed';
import VideoGalleryItemController from 'cms/pages/gallery/video_gallery/controller/VideoGalleryItemController';

export default function PostGalleryItem({ item, showDelete = true, onDelete }) {

    const { modalIsOpen, setModalIsOpen, _delete, _changeFeatured, is_featured } = VideoGalleryItemController(item,onDelete)

    return (
        <>

            <div key={item.id} className="col-md-4 col-sm-4">
                <div className="document-container">
                    <div className="document" onClick={() => { setModalIsOpen(true) }} >
                        {isYoutube(item.url) && (
                            <img
                                src={`https://img.youtube.com/vi/${getYoutubeId(item.url)}/0.jpg`}
                                className="img-fluid"
                                alt=""
                            />
                        )}
                        <span className="infoicon">
                            <i className="fa fa-play"></i>
                        </span>
                    </div>
                    <div className="document-info">
                        <div className="date">
                            {item.created_at.split('T')[0]}
                        </div>
                        <div className="document-info-buttons">
                            {showDelete && <DeleteButton />}
                            {/* <EditButton /> */}
                            {/* <FeaturedButton /> */}
                        </div>
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <CustomModal
                    isOpen={modalIsOpen}
                    setIsOpen={setModalIsOpen}
                >
                    <>
                        {(item && item.url != null && item.url !== "undefined") && <UrlEmbed url={item.url} />}
                    </>
                </CustomModal>
            )}

        </>

    );

    function DeleteButton() {
        return <div
            className="btn color-white pull-right"
            onClick={() => {
                if (window.confirm('Are you sure you wish to delete this item?'))
                    _delete();
            }}
        >
            {" "}
            <i className="fa fa-trash"></i>
        </div>;
    }

    function EditButton() {
        return <div
            className="btn color-white pull-right"
            onClick={() => {

            }}
        >
            {" "}
            <i className="fa fa-edit"></i>
        </div>;
    }

    function FeaturedButton() {
        return <div
            className={`btn-featured ${is_featured ? 'color-gold' : 'color-white'} pull-right`}
            onClick={() => {

                _changeFeatured()
            }}
        >
            {" "}
            <i className="fa fa-star"></i>
        </div>;
    }
}


